import React from 'react';
import { useTranslation } from 'react-i18next'; 
import { ReactComponent as NoStock } from '../../../assets/SVG/NoStockFound.svg';
import Grid2 from '@mui/material/Grid2';

interface NoStockFoundProps {
  message?: string;
}
const NoStockFound: React.FC<NoStockFoundProps> = ({ message }) => {
  const { t: tStock } = useTranslation('stock_config');
  const displayMessage = message || tStock('No_Stock_Found_Message');

  return (
    <Grid2 
      container 
      justifyContent="center" 
      alignItems="center" 
      height={'100%'}
    >
      <Grid2>
        <NoStock style={{ width: '600px', height: '400px', marginTop: '64px' }} />
        <p style={{ textAlign: 'center', fontWeight: 600 }}>
          {displayMessage}
        </p>
      </Grid2>
    </Grid2>
  );
};

export default NoStockFound; 